import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export const useGetWorkspaceUsersQuery = (workspaceId: string) => {
  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["users", workspaceId],
    queryFn: async () => {
      const { data } = await authApi.get<Array<WorkspaceUser>>(
        `/workspace/users/${workspaceId}`
      );
      return data;
    },
  });

  return result;
};
